import sdk from '@trazi/digital-products/sdk/node';

const digitalProductsSDK = (window, opts = {}) => {
  return sdk(`${window.location.origin}/api`, opts);
};

export default digitalProductsSDK;
